// extracted by mini-css-extract-plugin
module.exports = {"formColorPickerHue":"HuePointer_formColorPickerHue__Uuwt5","formColorPickerItem":"HuePointer_formColorPickerItem__uWIco"};